import {BikePartTypeEnum} from '@/models/digital-document-queue-sender-transfer-protocol-form-model';
import i18n from '@/i18n/config';
import { LF } from '@/i18n/LF';

export function bikePartTypeNameFilter(type: BikePartTypeEnum) {
  switch (type) {
    case BikePartTypeEnum.FrontWheel:
      return i18n.t(LF.FrontWheel) as string;
    case BikePartTypeEnum.FrontFender:
      return i18n.t(LF.FrontFender) as string;
    case BikePartTypeEnum.RearFender:
      return i18n.t(LF.RearFender) as string;
    case BikePartTypeEnum.RearWheel:
      return i18n.t(LF.RearWheel) as string;
    case BikePartTypeEnum.Seat:
      return i18n.t(LF.Seat) as string;
    case BikePartTypeEnum.Frame:
      return i18n.t(LF.Frame) as string;
    case BikePartTypeEnum.SteeringWheel:
      return i18n.t(LF.SteeringWheel) as string;
    case BikePartTypeEnum.Trunk:
      return i18n.t(LF.Trunk) as string;
    default:
      return '';
  }
}
